import { useFlagSuperOnaEnabled } from "@/hooks/use-flag";
import type { PlainEnvironment } from "@/queries/environment-queries";
import { showStop } from "@/routes/environments/phase";
import { EnvironmentPhase } from "gitpod-next-api/gitpod/v1/environment_pb";

/**
 * Returns whether the Stop action should be enabled for the given environment.
 *
 * When SuperOna is enabled, environments are always stoppable except when
 * deleted or deleting. When the flag is off, the existing showStop behavior
 * is preserved (stoppable when desired phase is CREATING/STARTING/UPDATING/RUNNING).
 */
export function useCanStopEnvironment(environment: PlainEnvironment | undefined): boolean {
    const { value: isSuperOnaEnabled } = useFlagSuperOnaEnabled();

    if (!environment) {
        return false;
    }

    if (isSuperOnaEnabled) {
        const desired = environment.spec?.desiredPhase ?? EnvironmentPhase.UNSPECIFIED;
        return desired !== EnvironmentPhase.DELETED;
    }

    return showStop(environment);
}
